import { useEffect, useRef } from "react";
import { autoRegisterWebPushIfPermitted } from "../notifications/webPushClient";

/**
 * Após login, registra push silenciosamente se a permissão do navegador já estiver concedida.
 * Cada aparelho mantém sua própria inscrição (multi-dispositivo).
 */
export function useAutoWebPushRegister(enabled) {
  const ranRef = useRef(false);

  useEffect(() => {
    if (!enabled) {
      ranRef.current = false;
      return;
    }
    if (ranRef.current) return;
    ranRef.current = true;

    const timer = window.setTimeout(() => {
      void autoRegisterWebPushIfPermitted();
    }, 1200);

    return () => window.clearTimeout(timer);
  }, [enabled]);
}
